import React from 'react'
import { excludeKeysForText, hasSpecialCharactersWithRegex } from '../../../../constants/constant';
function InputLayout({ id = '', disable = false, name, className = '', value = '', type = 'text', onChange = () => { }, onClick = () => { }, onBlur = () => { }, placeholder = '', inputRange = '' }) {


 
  const preventUserToAddSymbol = (evt) => {
    if ((type === "text" &&excludeKeysForText.includes(evt?.key))) {
      evt.preventDefault();
    }
    if (eval(inputRange) === (-20) || eval(inputRange) === (-11)) {
      if ((type === "number" && (evt.key === 'e' || evt.key === '+'))) {
        evt.preventDefault();
      }
    } else {
      if ((type === "number" && (evt.key === 'e' || evt.key === '+' || evt.key === '-'))) {
        evt.preventDefault();
      }
    }
};




const handleChange = (e) => {
  const newValue = e.target.value;
  if (!hasSpecialCharactersWithRegex(newValue)) {
    onChange(e);
  }
};
return (
  <input id={id} autoComplete='off' onKeyDown={preventUserToAddSymbol} disabled={disable} onClick={onClick} name={name} className={`block w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
    ${disable ? 'bg-gray-100 text-[#25282b] cursor-not-allowed border-gray-300' : 'bg-white text-black border-gray-300'} 
    ${className}`} value={value} type={type} onChange={handleChange} onBlur={onBlur} placeholder={placeholder} />

)
}

export default InputLayout
